import MicrosoftAnalyticsEvent from '@github-ui/microsoft-analytics-event-element/MicrosoftAnalyticsEvent'
import {ShowPage} from './ShowPage'

export const ThankYouPage = () => {
  return (
    <>
      <ShowPage />
      <MicrosoftAnalyticsEvent />
    </>
  )
}

try{ ThankYouPage.displayName ||= 'ThankYouPage' } catch {}